import { PageHeader } from '~/components/Page/Page.Header';
import { translate } from '~/utils/translation.utils';

export const DataManagementPanelHeader = () => {
  return <PageHeader title={translate('dataManagement.panel.panelHeader')} />;
};
